<!-- 由 Dioa 创建于 2022-08-25 星期四 -->
<template>
  <div class="user-mark">
    <div class="form-item">
      <label for="">备注</label>
      <van-field
        v-model.trim="remark_name"
        placeholder="输入自定义备注"
        maxlength="5"
        show-word-limit
      />
      <span>*推荐设置备注名与学员群内备注一致，方便对应上学员哦</span>
    </div>

    <div class="form-item">
      <label for="">姓名</label>
      <input
        autocomplete="off"
        type="text"
        placeholder="输入姓名"
        v-model="userInfo.truename"
        disabled
      />
    </div>

    <div class="form-item" style="margin-bottom: 0">
      <label for="">微信昵称</label>
      <input
        autocomplete="off"
        type="text"
        placeholder="输入微信昵称"
        v-model="userInfo.nickname"
        disabled
      />
    </div>

    <div class="submit-btn" @click="onSubmit">完成</div>
  </div>
</template>

<script>
export default {
  name: 'user-mark',

  components: {},

  props: {},

  data() {
    return {
      remark_name: '',
      userInfo: {
        remark_name: '',
        truename: ''
      }
    }
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {
    this.getUserInfo()
  },

  destroyed() {},

  methods: {
    // 获取用户基本信息
    async getUserInfo() {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner'
      })
      try {
        let res = await this.$http.getApp('member/StudentData/getUserInfo', {
          unify_id: this.$route.query.unify_id,
          pid: this.$route.query.pid
        })
        this.$toast.clear()
        if (res?.data?.code === 200) {
          this.userInfo = res?.data?.data
          this.remark_name = this.userInfo.remark_name
        }
      } catch (err) {
        this.$toast.clear()
      }
    },

    // 提交
    async onSubmit() {
      if (!this.remark_name) {
        this.$toast.fail('请输入自定义备注!')
        return
      }
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner'
      })
      try {
        let res = await this.$http.getApp('member/StudentData/setRemarkName', {
          unify_id: this.$route.query.unify_id,
          remark_name: this.remark_name
        })
        this.$toast.clear()
        if (res?.data?.code == 200) {
          this.$toast.success('修改成功!')
          this.$router.back()
        } else {
          this.$toast.fail(res.data.msg)
        }
      } catch (err) {
        this.$toast.clear()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.user-mark {
  text-align: left;
  min-height: 100vh;
  background-color: #fafafa;
  padding: vw(20) vw(30);
  box-sizing: border-box;
  .form-item {
    margin-bottom: vw(24);
    ::v-deep .van-field__value {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .van-field__body {
        flex: 1;
      }
    }
    &:last-child {
      margin-bottom: 0;
    }
    label {
      display: block;
      font-size: vw(14);
      font-weight: 500;
      color: #000000;
      margin-bottom: vw(8);
    }
    input {
      padding: vw(14) vw(16);
      outline: none;
      background: #ffffff;
      border-radius: 8px;
      width: 100%;
      box-sizing: border-box;
      border: none;
      font-size: vw(14);
      font-weight: 500;
      color: #000000;
    }
    input[disabled='disabled'] {
      color: rgba(#000, 0.5);
    }
    span {
      margin-top: vw(7);
      font-size: vw(10);
      font-weight: 400;
      color: rgba(0, 0, 0, 0.4);
      display: inline-block;
    }
  }

  .submit-btn {
    width: 100%;
    padding: vw(12) 0;
    font-size: vw(14);
    font-weight: 500;
    color: #ffffff;
    background: #6236ff;
    border-radius: vw(10);
    text-align: center;
    margin-top: vw(80);
  }
}
</style>
